import TncDialog from './TncDialog';

export default TncDialog;
